import uiState from './reducers'
export const store = uiState
